import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { filterCommonAttributes } from '../ai-answer-dialog/analytics-helpers';
import type { commonAttributesType } from '../ai-answer-dialog/types';

export const onPersonCardOrgChartDwelled = (props: commonAttributesType): AnalyticsEventPayload => {
	const { source } = props;
	return {
		action: 'dwelled',
		actionSubject: 'personCardOrgChartModal',
		source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
		},
	};
};
